import { Directive, HostListener, Self } from '@angular/core';
import { MatTabGroup, MatTabHeader } from '@angular/material/tabs';

/** O ile pikseli przesuwamy pasek na jeden "ząbek" kółka. Mniej więcej szerokość połowy zakładki. */
const SCROLL_STEP_PX = 120;

const HEADER_SELECTOR = '.mat-tab-header';
/** Klasa, którą Material nadaje nagłówkowi dopiero wtedy, gdy zakładki nie mieszczą się w pasku. */
const PAGINATION_ENABLED_CLASS = 'mat-tab-header-pagination-controls-enabled';

/**
 * Przewijanie paska zakładek kółkiem myszy — zamiast klikania w strzałki paginacji na końcach paska.
 *
 * Material nie przewija nagłówka przez `scrollLeft`, tylko przesuwa listę zakładek transformacją CSS,
 * więc natywne przewijanie tu nie zadziała i trzeba sterować `scrollDistance` nagłówka. Wartość jest
 * po stronie Materiala obcinana do zakresu [0, maxScrollDistance], więc nie da się wyjechać poza pasek.
 *
 * Zdarzenie blokujemy (`preventDefault`) tylko wtedy, gdy faktycznie jest co przewijać — przy zakładkach
 * mieszczących się w całości kółko normalnie przewija stronę pod spodem.
 */
@Directive({ selector: 'mat-tab-group[appTabsWheelScroll]' })
export class TabsWheelScrollDirective {

  constructor(@Self() private tabGroup: MatTabGroup) { }

  @HostListener('wheel', ['$event'])
  onWheel(event: WheelEvent): void {
    const header = (event.target as HTMLElement)?.closest(HEADER_SELECTOR);
    if (!header?.classList.contains(PAGINATION_ENABLED_CLASS)) return;

    const delta = event.deltaY || event.deltaX;
    if (!delta) return;

    const tabHeader = this.tabGroup._tabHeader as MatTabHeader;
    tabHeader.scrollDistance += Math.sign(delta) * SCROLL_STEP_PX;
    event.preventDefault();
  }

}
